/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PortalRequestItem } from './PortalRequestItem';
import {
    PortalRequestItemFromJSON,
    PortalRequestItemFromJSONTyped,
    PortalRequestItemToJSON,
    PortalRequestItemToJSONTyped,
} from './PortalRequestItem';

/**
 * 
 * @export
 * @interface PortalRequest
 */
export interface PortalRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    message: string | null;
    /**
     * 
     */
    sent_at: Date | null;
    /**
     * 
     */
    due_at: Date | null;
    /**
     * 
     */
    items: Array<PortalRequestItem>;
}

/**
 * Check if a given object implements the PortalRequest interface.
 */
export function instanceOfPortalRequest(value: object): value is PortalRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('sent_at' in value) || value['sent_at'] === undefined) return false;
    if (!('due_at' in value) || value['due_at'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PortalRequestFromJSON(json: any): PortalRequest {
    return PortalRequestFromJSONTyped(json, false);
}

export function PortalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'sent_at': (json['sent_at'] == null ? null : parseDateTime(json['sent_at'])),
        'due_at': (json['due_at'] == null ? null : parseDateTime(json['due_at'])),
        'items': ((json['items'] as Array<any>).map(PortalRequestItemFromJSON)),
    };
}

export function PortalRequestToJSON(json: any): PortalRequest {
    return PortalRequestToJSONTyped(json, false);
}

export function PortalRequestToJSONTyped(value?: PortalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'message': value['message'],
        'sent_at': value['sent_at'] == null ? value['sent_at'] : serializeDateTime(value['sent_at']),
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'items': ((value['items'] as Array<any>).map(PortalRequestItemToJSON)),
    };
}

